import React from 'react'
import type { TagTone } from './TagInput'
import styles from './TagInput.module.css'

const toneChip: Record<TagTone, string> = {
  default: styles.chipDefault,
  positive: styles.chipPositive,
  negative: styles.chipNegative,
}

export type TagListProps = {
  tags: string[]
  tone?: TagTone
  className?: string
}

/** Read-only tag chips (e.g. mood entry cards) — same look as TagInput chips. */
const TagList = ({ tags, tone = 'default', className }: TagListProps) => {
  if (tags.length === 0) return null
  const chipTone = toneChip[tone]
  return (
    <div className={`${styles.chips} ${className ?? ''}`} role="list">
      {tags.map((t, i) => (
        <span
          key={`${t}-${i}`}
          className={`${styles.chipBase} ${chipTone}`}
          role="listitem"
        >
          <span className={styles.chipText}>#{t}</span>
        </span>
      ))}
    </div>
  )
}

export default TagList
